module.exports = __webpack_public_path__ + "media/images/lj_logo-a2ea3c561add3b1325f47320f8048592.png";